import { type SearchHit } from "@elastic/elasticsearch/lib/api/types";
import { type FC } from "react";
import { postExcerpt, removeMediaTags } from "~/utils";
import {
  buildHighlight,
  type ElasticSearchDocument,
} from "~/utils/elasticSearchUtils";

type ResultPostContentProps = {
  article: SearchHit<ElasticSearchDocument>;
};

export const ResultPostContent: FC<ResultPostContentProps> = ({ article }) => {
  const highlightedContent = buildHighlight(article.highlight);

  if (
    article.highlight?.post_content ||
    article.highlight?.["post_content.exact"]
  ) {
    return (
      <div
        className="break-words text-lg !leading-relaxed text-black sm:text-xl md:text-lg lg:text-xl"
        dangerouslySetInnerHTML={{
          __html: `${removeMediaTags(highlightedContent)}...`,
        }}
      />
    );
  }

  <div
    className="break-words text-lg !leading-relaxed text-black sm:text-xl md:text-lg lg:text-xl"
    dangerouslySetInnerHTML={{
      __html: postExcerpt(
        removeMediaTags(
          article._source?.post_excerpt || article._source?.post_content
        )
      ),
    }}
  />;
};
